<template>
  <v-dialog v-model="isOpenDialog" width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>THÊM HỌC SINH VÀO NHÓM</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card outlined class="ma-4 elevation-0">
        <AddStudentFilter />
      </v-card>
      <v-card outlined class="mx-4 mb-6 elevation-0">
        <ListStudents ref="list" />
      </v-card>
      <hr color="#E0E0E0" />
      <v-card-actions>
        <v-btn class="ma-2" outlined light width="100px" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <div class="pr-4 grey--text">Đã chọn {{ (selectedStudent || []).length }} học sinh</div>
        <v-btn class="ma-2" dark depressed color="#0D47A1" width="100px" @click="save">Thêm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import AddStudentFilter from '@/modules/tuitionFee/detail-group/dialogAddStudent/StudentFilter'
import ListStudents from '@/modules/mealConfig/dialogAddStudent/ListStudents'

export default {
  components: { AddStudentFilter, ListStudents },
  props: {
    groupId: { type: [String, Number], default: null }
  },
  data() {
    return { isOpenDialog: false }
  },
  computed: {
    ...mapState('mealGroupStudent', ['selectedStudent'])
  },
  methods: {
    ...mapActions('mealGroupStudent', ['addSelectedStudents']),
    ...mapMutations('mealGroupStudent', ['setSelectedStudent']),
    openDialog() {
      this.setSelectedStudent([])
      this.isOpenDialog = true
    },
    cancel() {
      this.isOpenDialog = false
    },
    async save() {
      if (!this.selectedStudent || !this.selectedStudent.length) {
        this.$alert.error('Vui lòng chọn ít nhất một học sinh!')
        return
      }
      this.$loading.active = true
      try {
        const errors = await this.addSelectedStudents(this.groupId)
        if (errors && errors.length) {
          this.$alert.error({ title: 'Có lỗi', description: errors.join('<br/>') })
        } else {
          this.$alert.success('Thêm học sinh thành công!')
        }
        if (this.$refs.list) this.$refs.list.clearSelected()
        this.setSelectedStudent([])
        this.isOpenDialog = false
        this.$emit('added')
      } catch (e) {
        this.$alert.error('Thêm học sinh thất bại: ' + e)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
